import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { ContentComponent } from './content/content.component';
import { FooterComponent } from './footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { TrainingComponent } from './training/training.component';
import { ModuleComponent } from './module/module.component';
import { LectureComponent } from './module/lecture/lecture.component';
import { LocalStorageModule } from 'angular-2-local-storage';

// Imports for loading & configuring the in-memory web api
import { Fixtures } from './fixtures';

// Data and other
import { FlowplayerDirective } from './flowplayer/flowplayer.directive';
import { PositionPipe } from './position.pipe';
import { VideoComponent } from './video/video.component';
import { LearnStructureComponent } from './learn-structure/learn-structure.component';
import { LearnStructureBottomComponent } from './learn-structure-bottom/learn-structure-bottom.component';

// Modals
import { ModalInputEmailComponent } from './modal-input-email/modal-input-email.component';
import { CommentComponent } from './comment/comment.component';


@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    ContentComponent,
    FooterComponent,
    TrainingComponent,
    ModuleComponent,
    LectureComponent,
    FlowplayerDirective,
    PositionPipe,
    VideoComponent,
    ModalInputEmailComponent,
    LearnStructureComponent,
    LearnStructureBottomComponent,
    CommentComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    LocalStorageModule.withConfig({
      prefix: 'ras',
      storageType: 'localStorage'
    })
  ],
  providers: [ NgbActiveModal, Fixtures ],
  bootstrap: [AppComponent],
  entryComponents: [ ModalInputEmailComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/app.module.ts